<template>
    <div>
        <div class="resource-containertwo swiper-container">
            <div class="swiper-wrapper one-wrapper">
                 <div class="resource-slide swiper-slide">

                    <div class="bottom-conternt bottom-conternttwo">
                        <a class="nectar-post-grid-link" target="_blank"
                            href="https://www.forbes.com/sites/anjalichaudhry/2025/07/01/beating-the-retreat-on-sustainability-a-losing-strategy-for-us-business/"
                            aria-label="AI can be beneficial for the marketing process">
                            <img style="height: 215px"  class="bottom-img" src="../assets/2024/05/2025-07-06.png" alt="" />
                            <div style="padding: 0px 20px">
                                <p class="bigsize">
                                   Beating The Retreat On Sustainability A Losing Strategy For US Business
                                </p>
                                <span class="meta-date">July 01, 2025</span>
                                <p class="text-overhidden">
                              Sustainability is increasingly out of favor in the U.S. In just a few short months, the federal government has withdrawn from key global commitments. The contrast with the rest of the world could not be starker. 
                                </p>

                              <div class="huisostion">
                                    <span class="huibutton">Insights</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="resource-slide swiper-slide">

                    <div class="bottom-conternt bottom-conternttwo">
                        <a class="nectar-post-grid-link" target="_blank"
                            href="https://www.wsj.com/articles/trade-war-roils-logistics-sector-after-2024s-relative-calm-a21ec101?gaa_at=eafs&gaa_n=ASWzDAgVc_OWswN8A5UIDSkLILcK62VHXY_hIPqGbF7GdS5U249fLDUVi8j9&gaa_ts=68640cfc&gaa_sig=pSruS-721OuSj_MEm6KbitioxK5OJh9vSmf2SUVepQCqmPdyHudoFbItPnlmTUpwJjYwUhDaZdW6jkva0fWaWQ%3D%3D"
                            aria-label="AI can be beneficial for the marketing process">
                            <img style="height: 215px"  class="bottom-img" src="../assets/2024/05/2025-07-5.png" alt="" />
                            <div style="padding: 0px 20px">
                                <p class="bigsize">
                                    Trade War Roils Logistics Sector After 2024’s Relative Calm
                                </p>
                                <span class="meta-date">June 03, 2025</span>
                                <p class="text-overhidden">
                                  U.S. companies face rising logistics costs, supply-chain upheaval and uncertain consumer demand this year amid a global trade war, freight-sector experts say. 
                                </p>

                              <div class="huisostion">
                                    <span class="huibutton">Insights</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="resource-slide swiper-slide">

                    <div class="bottom-conternt bottom-conternttwo">
                        <a target="_blank" class="nectar-post-grid-link"
                            href="https://gfmag.com/economics-policy-regulation/esg-in-asia/"
                            aria-label="AI can be beneficial for the marketing process">
                            <img class="bottom-img" src="../assets/2024/05/2024 02.png" alt="" style="height: 215px" />
                            <div style="padding: 0px 20px" class="huipostrive">
                                <p class="bigsize">ESG's Future in Asia</p>
                                <span class="meta-date">April 02, 2024</span>
                                <p class="text-overhidden">
                                    The future path of ESG may well depend on choices made
                                    by the rest of the world, and particularly Asia. Why
                                    Asia?
                                </p>
                                <div class="huisostion">
                                    <span class="huibutton">Insights</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="resource-slide swiper-slide">

                    <div class="bottom-conternt bottom-conternttwo">
                        <a target="_blank" class="nectar-post-grid-link"
                            href="https://www.nytimes.com/2024/07/09/business/economy/economic-data-response-rates/"
                            aria-label="AI can be beneficial for the marketing process">
                            <img class="bottom-img" src="../assets/2024/05/july09 2024.png" style="height: 215px"
                                alt="" />
                            <div style="padding: 0px 20px" class="huipostrive">
                                <p class="bigsize">
                                    Data Reliability: U.S. Economic Data Is in Jeopardy,
                                    Study Finds
                                </p>
                                <span class="meta-date">July 09, 2024</span>
                                <p class="text-overhidden">
                                    A report issued on July 2, 2024 by the American
                                    Statistical Association concludes that government...
                                </p>
                                <div class="huisostion">
                                    <span class="huibutton huibuttonabsolute">Insights</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="resource-slide swiper-slide">
                    <div class="bottom-conternt bottom-conternttwo">
                        <a target="_blank" class="nectar-post-grid-link"
                            href="https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/a-data-leaders-technical-guide-to-scaling-gen-ai/"
                            aria-label="AI can be beneficial for the marketing process">
                            <img class="bottom-img" src="../assets/2024/05/202408.png" alt="" style="height: 215px" />
                            <div style="padding: 0px 20px" class="huipostrive">
                                <p class="bigsize">
                                    A data leader’s technical guide to scaling gen AI
                                </p>
                                <span class="meta-date">July 08, 2024</span>
                                <p class="text-overhidden">
                                    The emergence of gen AI is forcing data and AI leaders
                                    to revisit their data platforms...
                                </p>
                                <div class="huisostion">
                                    <span class="huibutton">Insights</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="resource-slide swiper-slide">

                    <div class="bottom-conternt bottom-conternttwo">
                        <a target="_blank" class="nectar-post-grid-link"
                            href="https://csi.metadesigndemos.com/ai-can-be-beneficial-for-the-marketing-process-2/"
                            aria-label="AI can be beneficial for the marketing process">
                            <img class="bottom-img"
                                src="../assets/2024/01/655d836e7c89f6993fe4cf05_X-examples-of-AI-generated-content_blog-listing-768x614.png"
                                alt="" style="height: 215px" />
                            <div style="padding: 0px 20px" class="huipostrive">
                                <p class="bigsize">
                                    AI can be beneficial for the marketing process
                                </p>
                                <span class="meta-date">January 30, 2024</span>
                                <p class="text-overhidden">
                                    Do you have a to-do list of pesky tasks lingering over
                                    you? We’re talking about…
                                </p>
                                <div class="huisostion">
                                    <span class="huibutton huibuttonabsolute">Insights</span>
                                </div>
                            </div>
                        </a>

                    </div>
                </div>













            </div>
            <div class="swiper-button-prev">
                <!-- <i class="el-icon-right"></i> -->
            </div>
            <div class="swiper-button-next">
                <!-- <i class="el-icon-back"></i> -->
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
export default {
    name: "Products",
    props: {
        //  mobel: {
        //     type: Boolean,
        //     default: false,
        //   },
    },
    data() {
        return {
            mobel: false,

        };
    },
    watch: {
        "$route.hash": function () {
            // 在这里可以处理hash变化后的逻辑
            // this.scrollToAnchor()
        },
    },
    methods: {
        menuSeen() {
            // 屏幕尺寸
            let screenHeight = document.body.clientWidth;

            if (screenHeight > 1000) {
                this.mobel = false;
                this.getSwiper();
            } else {
                if (screenHeight < 1000) {
                    this.mobel = true;
                    // if(screenHeight == 1000){
                    this.getSwiper();
                    // }
                }
            }
        },
        getSwiper() {
            this.swiper = new Swiper(".resource-containertwo", {
                loop: false, // 无缝
                // autoplay: { //自动开始
                //     delay: 3000, //时间间隔
                //     disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                // },
                paginationClickable: true,
                slidesPerView: this.mobel ? 2 : 4, // 一组三个
                spaceBetween: 20, // 间隔
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
                observer: true,
                observeParents: true,
                // 如果需要分页器
                // pagination: {
                //   el: ".swiper-pagination",
                //   clickable: true, // 分页器可以点击
                // },
            });
        },
    },
    mounted() {
        this.getSwiper();
        window.addEventListener("resize", this.menuSeen);
        this.menuSeen();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.menuSeen);
    },
};
</script>

<style scoped>
.swiper-button-next,
.swiper-button-prev {
    /* right: 10px;
    left: auto; */
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: #fff;
    color: black;
}

.swiper-button-prev:after,
.swiper-button-next:after {
    font-size: 16px;
}

.bottom-conternt {
    position: relative;
    /* width: 24%; */
    background-color: #fff;
    /* font-family: Alegreya Sans; */
    font-size: 18px;
    line-height: 38px;
    padding-bottom: 20px;
    max-width: 330px;
    margin-top: 70px;
    margin-left: 20px;
    margin-bottom: 20px;
    transition: transform 0.42s ease, background-color 0.42s ease;
    overflow: hidden;
}

.bigsize {
    font-size: 28px;
    margin-bottom: 20px;
    display: -webkit-box;
    /* 使用弹性盒模型 */
    -webkit-box-orient: vertical;
    /* 垂直方向排列 */
    -webkit-line-clamp: 2;
    /* 限制为两行 */
    overflow: hidden;
    /* 超出部分隐藏 */
    text-overflow: ellipsis;
    /* 使用省略号表示超出部分 */
    height: 3em;
    /* 设置高度以适应两行文本 */
    line-height: 1.5em;
}

.about-box-bottom {
    margin: 0 5%;
    padding-top: 20px;
    padding-bottom: 8%;
}

.bottom-conternt:hover {
    transform: translateY(-4px);
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    /* box-shadow: 0 30px 60px rgba(0, 0, 0, .15); */
}

.bottom-conternt:hover .bottom-img {
    transform: scale(1.1);
}

.bottom-img {
    position: relative;
    width: 104%;
    height: 260px;
    transition: transform 0.42s ease, background-color 0.42s ease;
}

.bigsize {
    font-size: 28px;
    margin-bottom: 20px;
    display: -webkit-box;
    /* 使用弹性盒模型 */
    -webkit-box-orient: vertical;
    /* 垂直方向排列 */
    -webkit-line-clamp: 2;
    /* 限制为两行 */
    overflow: hidden;
    /* 超出部分隐藏 */
    text-overflow: ellipsis;
    /* 使用省略号表示超出部分 */
    height: 3em;
    /* 设置高度以适应两行文本 */
    line-height: 1.5em;
}

.text-overhidden {
    overflow: hidden;
    /* 隐藏超出部分 */
    display: -webkit-box;
    /* 使用弹性布局 */
    -webkit-box-orient: vertical;
    /* 垂直方向的布局 */
    -webkit-line-clamp: 3;
}

.meta-date {
    margin-bottom: -20px;
}

a {
    text-decoration: none;
    color: #000000;
}

body {
    font-size: 18px;
}

p {
    font-size: 18px;
}

b {
    font-weight: 400;
}
</style>